import React from 'react';
import Style from './radio-button.module.css';
/** @jsxImportSource @emotion/react */

import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";

const RadioButton = props => {
  const propsArray = [];
  propsArray.className = props.className === undefined ? '' : props.className;
  propsArray.label = props.label === undefined ? '' : props.label;
  propsArray.name = props.name === undefined ? 'default' : props.name;
  propsArray.value = props.value === undefined ? 'default' : props.value;
  propsArray.disabled = propsArray.disabled === undefined || propsArray.disabled === false ? false : true;
  propsArray.size = Style[props.size === undefined ? 'md' : props.size];
  propsArray.color = Style[props.color === undefined ? 'primary' : props.color];
  let emotionStyle = [];

  if (props.ms !== undefined) {
    emotionStyle = props.ms;
  }

  const selectRadioButton = event => {
    let radioButton = [];
    radioButton = document.querySelectorAll(`input[name=${propsArray.name}]`);
    radioButton.forEach(obj => {
      let classList = obj.closest(`.${Style.radioButton}`).querySelector(`.${Style.circle}`).className;
      let classListArray = classList.split(' ');
      obj.closest(`.${Style.radioButton}`).querySelector(`.${Style.circle}`).classList.remove(classListArray[2]);
    });
    event.target.closest(`.${Style.radioButton}`).querySelector(`.${Style.circle}`).classList.add(propsArray.color);
  };

  return _jsxs(React.Fragment, {
    children: [propsArray.className === '' && _jsx("div", {
      className: `${Style.radioButton}`,
      css: emotionStyle,
      children: _jsxs("label", {
        onChange: selectRadioButton,
        className: `${propsArray.size}`,
        children: [_jsx("div", {
          className: `${Style.circle} ${propsArray.size}`,
          children: _jsx("div", {
            className: `${Style.inner}`
          })
        }), propsArray.label, _jsx("input", {
          onChange: event => props.onChange(event.target.value),
          className: "d-none",
          name: propsArray.name,
          value: propsArray.value,
          type: "radio",
          disabled: props.disabled
        })]
      })
    }), propsArray.className !== '' && _jsx("div", {
      className: `${Style.radioButton}`,
      css: emotionStyle,
      children: _jsxs("label", {
        onChange: selectRadioButton,
        className: `${propsArray.size}`,
        children: [_jsx("div", {
          className: `${Style.circle} ${propsArray.size}`,
          children: _jsx("div", {
            className: `${Style.inner}`
          })
        }), propsArray.label, _jsx("input", {
          onChange: event => props.onChange(event.target.value),
          className: "d-none",
          name: propsArray.name,
          value: propsArray.value,
          type: "radio",
          disabled: props.disabled
        })]
      })
    })]
  });
};

export default RadioButton;